<script>
  export let type = "primary";
  export let flat = false;
  export let inverse = false;
  export let fullWidth = false;
  export let small = false;
</script>

<button
  class={type}
  class:flat
  class:inverse
  class:fullWidth
  class:small
  on:click
>
  <slot />
</button>

<style>
  button {
    border: 0;
    cursor: pointer;
    padding: 0.6em 1em;
    font-weight: 600;
    box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.2);
  }
  .primary {
    background-color: #00afb9;
    color: white;
  }
  .secondary {
    background-color: grey;
    color: white;
  }
  .danger {
    background-color: #dc3545;
    color: white;
  }
  .flat {
    box-shadow: none;
  }
  .inverse {
    background-color: white;
    color: black;
    border-color: #ccc;
  }
  .fullWidth {
    width: 100%;
  }
  .primary.inverse {
    border: 1px solid #00afb9;
    color: #00afb9;
  }
  .secondary.inverse {
    border: 1px solid grey;
    color: grey;
  }
  .danger.inverse {
    border: 1px solid #dc3545;
    color: #dc3545;
  }
  .small {
    padding: 0.5em 0.7em;
    font-weight: 400;
    font-size: 0.9em;
  }
</style>
